import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from '../../CommonDT';
import { _delete, _get, _post, _put, _req } from '../../request';

export type PayOrderDataType = CommonDT & {
  incId: number; // 自增id
  productName: string; // 商品名称
  productMoney: number; // 商品价格，BigDecimal 对应 TypeScript 的 number
  systemNotifyUrl: string; // 系统异步通知url
  systemReturnUrl: string; // 系统同步跳转url
  systemTradeNo: string; // 系统交易单号（V免签订单号）
  merchantId: number; // 商户id
  merchantTradeNo: string; // 商户交易单号（不建议重复）
  tradeType: string; // 交易类型（alipay，wxpay）
  tradeStatus: number; // 交易状态（TRADE_SUCCESS已支付）
  tradeSignType: string; // 交易签名类型（默认md5）
  tradeSign: string; // 交易签名
  isComplete: number; // 已完成（1已完成）
  fkUserUuid: string; // 用户id
  fkUsergroupUuid: string; // 用户组id
  fkVipUuid: string; // 用户vip
};

export type PayOrderBatchDataType = {
  payOrders: PayOrderDataType[];
};

export type PayOrderPageDataType = {
  pageParams: PageParams;
  filter?: PayOrderDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get('/usr/payOrder/', id);
};

const list = async (data?: PayOrderDataType): Promise<ResultType> => {
  return await _post('/usr/payOrder/list', data);
};

const page = async (data?: PayOrderPageDataType): Promise<ResultType> => {
  return await _post('/usr/payOrder/page', data);
};

const batchSave = async (data: PayOrderBatchDataType): Promise<ResultType> => {
  return await _post('/usr/payOrder/batchSave', data);
};

const batchUpdate = async (data: PayOrderBatchDataType): Promise<ResultType> => {
  return await _put('/usr/payOrder/batchUpdate', data);
};

const alterStatus = async (payOrderId: string, status: number): Promise<ResultType> => {
  return await _req('/usr/payOrder/alterStatus', 'PUT', { payOrderId, status });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete('/usr/payOrder/batchRemove', ids);
};
const getBySystemTradeNo = async (systemTradeNo: string): Promise<ResultType> => {
  return await _req('/usr/payOrder/getBySystemTradeNo', 'GET', { systemTradeNo });
};
const getByMerchantTradeNo = async (merchantTradeNo: string): Promise<ResultType> => {
  return await _req('/usr/payOrder/getByMerchantTradeNo', 'GET', { merchantTradeNo });
};

const PayOrderApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  getBySystemTradeNo,
  getByMerchantTradeNo,
};

export default PayOrderApi;
